// extracted by mini-css-extract-plugin
export default {"component":"vitrineProductForm__component___IGKsR","textField":"vitrineProductForm__textField___a5pjw"};